export const couponDicionaryError: Record<string, string> = {
  [`doesn't have ICMS origin configured`]: 'Há peça sem dados de tributação',
  [`doesn't have state subscription`]:
    'Empresa não tem inscrição estadual configurado',
};
